import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
    Button,
    makeStyles,
    Box,
    Typography,
    Container,
} from "@material-ui/core";
import { useForm } from "../../../hooks/useForm";
import { useHistory, useParams } from "react-router";
import { startAlerta } from "../../../actions/ui/alertas";
import AfiliadoService from '../../../services/AfiliadoService'
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { finishSpinner, startSpinner } from "../../../actions/ui/spinner";

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%'
    },
    submit: {
        marginTop: "1rem",
        textTransform:"none"
    },
    title: {
        fontWeight: "bold",
        marginBottom: "2rem"
    }
}));

export const RestaurarPasswordScreen = () => {
    const history = useHistory()
    const classes = useStyles();
    const { token } = useParams();

    const [verFormulario, setVerFormulario] = useState(false)

    const initialState = {
        password: "",
        confirmPassword: ""
    };

    const [formValues, handleInputChange] = useForm(initialState);

    const { password, confirmPassword } = formValues;

    const dispatch = useDispatch();

    useEffect(() => {

        // custom rule will have name 'isPasswordMatch'
        ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
            if (value !== password) {
                return false;
            }
            return true;
        });
    })


    const handleChangePassword = async (e) => {
        e.preventDefault();
        try {
            dispatch(startSpinner())
            const data = {
                newPassword: password,
                token
            }
            const result = await AfiliadoService.resetPassword(data)
            const body = await result.json()
            if (result.ok) {
                dispatch(finishSpinner())
                dispatch(startAlerta("¡Contraseña actualizada exitosamente!", "success"))
                history.push("/afiliado/ingreso")
            } else {
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if (error.mensaje) {
                dispatch(startAlerta(error.mensaje, "error"))
            } else {
                dispatch(startAlerta("Ha ocurrido un error en el cambio de contraseña. Intente nuevamente.", "error"))
            }
            console.log("Error en el cambio de contraseña del usuario", error)
        }
    };

    if (!verFormulario && (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i))) {
    return (
        <div className={classes.root}>
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    <Typography align="center" variant="h4" className={classes.title} color="secondary">Nueva contraseña</Typography>
                    <Typography align="center">Hemos detectado que estas intentando cambiar tu contraseña desde tu dispositivo móvil.</Typography>
                    <Typography align="center">¿Deseas continuar por la app o por la web?</Typography>
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={{ marginTop: "2rem" }}
                        component="a"
                        href={`ospedyc://password-reset/${token}`}//URL de la app
                    >
                        Continuar por la app
                        </Button>
                    <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        style={{ marginTop: "0.5rem" }}

                        onClick={() => setVerFormulario(true)}
                    >
                        Continuar por la Web
                        </Button>
                </Container>
            </Box>
        </div>
    )
    }

    return (
        <div className={classes.root}>
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="center"
            >
                <Container maxWidth="sm">
                    <ValidatorForm onSubmit={handleChangePassword}>
                        <Box p="1rem">
                            <Typography align="center" variant="h4" className={classes.title} color="secondary">Nueva contraseña</Typography>
                            <Typography variant="body2" align="justify" style={{ marginTop: "1rem" }}>A continuación, ingrese su nueva contraseña para poder actualizarla.</Typography>

                            <TextValidator
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Nueva Contraseña"
                                onChange={handleInputChange}
                                name="password"
                                type="password"
                                validators={['required']}
                                errorMessages={['La nueva contraseña es requerida']}
                                value={password}
                            />
                            <TextValidator
                                variant="outlined"
                                margin="normal"
                                fullWidth
                                label="Confirmación nueva contraseña"
                                onChange={handleInputChange}
                                name="confirmPassword"
                                type="password"
                                validators={['isPasswordMatch', 'required']}
                                errorMessages={['Las nuevas contraseñas deben ser iguales', 'La confirmación de la nueva contraseña es requerida']}
                                value={confirmPassword}
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}
                            >
                                Cambiar contraseña
                            </Button>
                        </Box>
                    </ValidatorForm>
                </Container>
            </Box>
        </div>
    );
};
